<script setup>
const props = defineProps({
    prependIcon: {
        type: String,
        default: '',
        required: false,
    },
});
</script>

<template>
    <v-btn
        class="primaryshade"
        color="primaryshade"
        type="submit"
        :prepend-icon="prependIcon ? prependIcon : ''"
    >
        <slot />
    </v-btn>
</template>

<style scoped>

</style>
